module.exports = __webpack_public_path__ + "img/sa.sa0ac9ef7.svg";